import React, { useReducer, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import Button from 'b2b-ui-components-lib/lib/components/button';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import B2bCommonFeasibilityWidget from 'b2b-common-feasibility-widget';
// import Input from 'b2b-ui-components-lib/lib/components/input';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
// import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import { DEDICATED_COMMON_PARAMS, PRODUCT_TYPE, ROUTES, isBulkUpgrade, isShiftingJourney } from 'common/constants/app.constants';
import { getAccordionVariant, findParamFromUrl, getOrderDetails } from 'common/utils/app.utils';
import { checkOftFeasibilityStatus, createLead, createSiebelLead, checkOftFeasibilityStatusDedicated, getCommercialAttributesList } from 'common/helper/api.helper';

import {
  correlation,
  getFromSessionStorage,
  setInSessionStorage,
  // gtag_report_conversion_customer_details,
  gtag_report_conversion_lead_submitted,
  // facebookNextButtonTag,
  facebookProceedButtonTag
} from 'common/utils/app.utils';

import appConfig from 'config/config';

import {
  // CUSTOMER_COMPANY_NAME,
  // CUSTOMER_EMAIL,
  // CUSTOMER_NAME,
  // CUSTOMER_PHONENUMER,
  // CUSTOMER_UNIQUEID,
  FETCH_SUCCESS,
  FETCH_ERROR,
  INITIATE_FETCHING,
  MODULE_ID,
  // INSTALLATION_PAGE_CUSTOMER_DETAIL,
  AUTHORIZATION_HEADER,
  FEASIBILITY_RESPONSE,
  DEDICATED_FEASIBILITY_RESPONSE,
  // FEASIBILITY_STATUS,
  // FEASIBILITY_DATA,
  AUTHORIZED_SIGNATORY,
  // CUSTOMER_DETAIL,
  DEDICATED_CUSTOMER_DETAIL,
  DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL,
  DEDICATED_FEASIBILITY_DATA,
  BANDWIDTH_LIST,
  CAPEX_MEDIA_TYPE,
  mapToBandWidthList,
  // CUSTOMER_DETAIL,
  DEFAULT_FEASIBILITY_DATA
} from '../../../common/constants/constants';

import useApiHook from '../../../components/customHook/apiHook';

import {
  // fireAnalyticsOnFeasibilityPageLoad,
  // fireAnalyticsOnNextButtonClick,
  fireAnalyticsOnCustomerPageLoad
  // fireAnalyticsOnProceedButtonClick,
} from 'common/services/analytics';
import {
  faOnDedicatedAuthCheckFeasibiliyPage,
  faOnDedicatedCheckFeasibiliyLoad,
  faOnDedicatedCustomerDetailsLoad,
  faOnDedicatedNextClick,
  faOnDedicatedProceedClick
} from 'dedicated/services/analytics.service';
import { trackMOEEvent } from 'common/services/moengage.service';
import { MOENGAGE_ANALYTICS_EVENT } from 'common/constants/app.constants';
import { FeasibilityID } from 'singleSite/feasibility-id/feasibility-id';

import { FEASIBILITY_SUCCESS, MULTIPLE_SITE } from 'home/view/manage-feasibility/constants';
import './dedicatedaccordion.scss';
import { FEASIBILITY_STATUS_SCHEMA } from 'singleSite/network-status/network-constant';
import { getInstallationDetailsAccordionHeading } from 'home/view/check-feasibility/comp-generator/component.generator';
import CancelModal from 'home/view/manage-feasibility/components/molecules/CancelModal';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { MULTI_SITE_MODULE_ID, AUTH_TOKEN, DEFAULT_TOAST_MSG, ERROR_TOAST } from 'home/view/manage-feasibility/constants';
import { cancelLead } from 'home/view/manage-feasibility/services';

// const initiatvalidationErrorsState = {
//   phoneNumber: false,
//   registeredEmail: getFromSessionStorage(MODULE_ID, 'submitdisabled'),
//   email: false,
//   name: false,
//   otpError: false
// };

let feasibilityCustomerDetailsConstant = {
  isHighRiseBuildingChecked: false,
  address: '',
  flatFloor: '',
  name: '',
  mobileNumber: '',
  addressObj: {
    addressString: '',
    city: ''
  },
  isLocateMe: false,
  highRiseOption: null,
  isFlatFloorFocusWordEdited: false,
  flatFloorFocusWord: '',
  selectedStringFromAutoSuggest: null,
  isEditedStringFromAutoSuggest: false,
  autoCompleteQueryString: '',
  consentFlag: false,
  pincode: '',
  lastMile: null
};
const initialAccordionState = {
  installation: false,
  customer: true
};

// const otpPageRedirectAccordionState = {
//   installation: true,
//   customer: false
// };
const planObj = {
  maxBandwidth: null
};
// const bandWidthList = BANDWIDTH_LIST;
// const setError = (state, action) => {
//   switch (action.type) {
//     case CUSTOMER_PHONENUMER:
//       return { ...state, phoneNumber: action.value, otpError: false };
//     case CUSTOMER_EMAIL:
//       return { ...state, email: action.value };
//     case CUSTOMER_NAME:
//       return { ...state, name: action.value };
//     case 'registeredEmail':
//       return { ...state, registeredEmail: action.value };
//     default:
//       return { ...state };
//   }
// };

const setAccordion = (state, action) => {
  switch (action.type) {
    case 'installation':
      return { ...state, installation: action.value, customer: !action.value };
    case 'customer':
      return { ...state, customer: action.value, installation: !action.value };
    case 'installation_success':
      return { customer: false, installation: true };
    default:
      return { ...state };
  }
};

function AccordionComponent(props) {
  let {
    setToast,
    history,
    stateToken,
    code,
    redirectToPage,
    isdedicatedJourney,
    isUnAuthJourney,
    productType,
    selectedRadio = {},
    setRequestType = () => {},
    showAccordion = true,
    showAddFeasibilityId = true,
    showBandwidthField = true,
    showLastMileField = true,
    showLatField = true,
    showLongField = true,
    onSubmitCb = () => {},
    cancelPnQLead = () => {},
    onAddFeasibilitySuccess = () => {},
    selectedBandwidth
  } = props;
  const [feasibilityData, setFeasibilityData] = useState(null);
  const [instAddressValidated, setInstAddressValidated] = useState(false);
  const [contactDetailsValidated, setContactDetailsValidated] = useState(false);

  let contactRef = useRef();
  const widgetFrameRef = useRef(null);
  let dedicatedAccordianRef = useRef();

  const authorizedSignatory = getFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
  const initialCustomerDetails = {
    companyName: authorizedSignatory && authorizedSignatory.companyName ? authorizedSignatory.companyName : '',
    customerName: authorizedSignatory && authorizedSignatory.kdmName ? authorizedSignatory.kdmName : '',
    phoneNumber: authorizedSignatory && authorizedSignatory.mobile ? authorizedSignatory.mobile : '',
    email: authorizedSignatory && authorizedSignatory.email ? authorizedSignatory.email : '',
    otpSuccess: false,
    uniqueId: '',
    code: ''
  };

  const authToken = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  let getfeasibilityData = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
  let existingCustomerDetails = getFromSessionStorage(MODULE_ID, DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL);
  let customerDetails = initialCustomerDetails;
  let accordionDetail = initialAccordionState;
  if (customerDetails && customerDetails.companyName && !getfeasibilityData) {
    //defaultFeasibilityValue=DEFAULT_FEASIBILITY_DATA;
    getfeasibilityData = DEFAULT_FEASIBILITY_DATA;
    getfeasibilityData.companyName = customerDetails.companyName;
  }
  // let validationErrorState = initiatvalidationErrorsState;

  // const [accordionMetadata, setAccordionMetadata] = useState({
  //   isValidated: true,
  //   isEditable: false,
  // });
  // let [createSiebelCalled, setcreateSiebelCalled] = useState(false);
  // let [submitdisabled, setsubmitdisabled] = useState(getFromSessionStorage(MODULE_ID, 'submitdisabled'));
  // let validationErrorState = initiatvalidationErrorsState;
  let [createSiebelCalled, setcreateSiebelCalled] = useState(false);
  let [submitdisabled, setsubmitdisabled] = useState(getFromSessionStorage(MODULE_ID, 'submitdisabled'));
  const [customer, setCustomer] = useState(customerDetails);
  // const [disabledProcced, setDisabledProcced] = useState(false);
  // const [validationError, setValidationError] = useReducer(setError, validationErrorState);
  const [accordionState, setAccordionState] = useReducer(setAccordion, accordionDetail);
  const [fetchState, setAPIFetechingState] = useApiHook();
  const [feasibilityCustomerDetails, setFeasibilityCustomerDetails] = useState();
  const [bandWidthList, setBandWidthList] = useState(BANDWIDTH_LIST);
  const [showFeasibilityId, setShowFeasibilityId] = useState(false);
  const [showCanceLeadPopup, setShowCancelLeadPopup] = useState(false);

  useEffect(() => {
    customerDetails = existingCustomerDetails ? existingCustomerDetails : initialCustomerDetails;
    setAPIFetechingState({ type: INITIATE_FETCHING });
    faOnDedicatedCheckFeasibiliyLoad();
    if (getfeasibilityData) {
      // console.log('getfeasibilityData', getfeasibilityData);
      if (customerDetails && customerDetails.companyName) {
        getfeasibilityData.companyName = customerDetails.companyName;
      }
      setFeasibilityCustomerDetails(getfeasibilityData);
    } else {
      if (customerDetails && customerDetails.companyName) {
        feasibilityCustomerDetailsConstant.companyName = customerDetails.companyName;
      }
      setFeasibilityCustomerDetails(feasibilityCustomerDetailsConstant);
    }
    if (authToken && getfeasibilityData) {
      // setContactDetailsValidated(true);
      setAccordionState({ type: 'installation_success' });
    }
    // if (stateToken) {
    //   setContactDetailsValidated(true);
    //   setAccordionState({ type: 'installation_success' });
    //   if (code && customerDetails.uniqueId === stateToken) {
    //     customerDetails.otpSuccess = true;
    //     customerDetails.code = code;
    //     submitLead();
    //   } else {
    //     validationErrorState.otpError = true;
    //     setCustomer({ ...customer, otpSuccess: false });
    //   }
    //   accordionDetail = otpPageRedirectAccordionState;
    // } else {
    //   faOnDedicatedCheckFeasibiliyLoad({ productType });
    // }

    faOnDedicatedCheckFeasibiliyLoad({ productType });
    setAPIFetechingState({ type: FETCH_SUCCESS });
    fetchProductBandwidthMbps();
    setFeasibilityData(getfeasibilityData);
  }, []);

  // const [instAddressValidated, setInstAddressValidated] = useState(false);
  // const [contactDetailsValidated, setContactDetailsValidated] = useState(false);
  const processFeasibilityResponse = (response, recommendedSiteSelected = false) => {
    faOnDedicatedNextClick(response);
    if (isUnAuthJourney) {
      trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_SUBMIT_FEASIBILITY);
      facebookProceedButtonTag();
    } else {
      trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.SUBMIT_FEASIBILITY);
    }

    checkUserFeasibility(response, recommendedSiteSelected, onSubmitCb);
  };

  // const updateCustomer = (action) => {
  //   const { value, type } = action;
  //   if (type === CUSTOMER_EMAIL) {
  //     setCustomer({ ...customer, [type]: value });
  //     setValidationError({ type: CUSTOMER_EMAIL, value: false });
  //     setValidationError({ type: 'registeredEmail', value: false });
  //   } else if (type === CUSTOMER_PHONENUMER) {
  //     setValidationError({ type: CUSTOMER_PHONENUMER, value: false });
  //     setCustomer({ ...customer, [type]: value, otpSuccess: false });
  //   } else if (type === CUSTOMER_NAME) {
  //     setCustomer({
  //       ...customer,
  //       [type]: value.replace(/[&\/\\#!@+()$~%'":*?<>{}0-9]/g, '')
  //     });
  //   } else if (type === CUSTOMER_COMPANY_NAME) {
  //     if (value.match("^([A-Za-z0-9 &:)(.#_',-\\/\\^])+$") || value === '') {
  //       setCustomer({
  //         ...customer,
  //         [type]: value
  //       });
  //     }
  //   } else {
  //     setCustomer({ ...customer, [type]: value });
  //   }
  // };

  // const checkValidation = (action) => {
  //   const { value, type } = action;
  //   let blockedDomains = ['yahoo', 'gmail', 'googlemail', 'facebook', 'msn', 'hotmail', 'rediffmail', 'live'];
  //   let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim;
  //   if (type === CUSTOMER_EMAIL) {
  //     if (value.length > 0 && value.match(emailRegex) && !localStorage.getItem('accessToken') && isdedicatedJourney) {
  //       setValidationError({ type: 'registeredEmail', value: false });
  //       setInSessionStorage(MODULE_ID, 'submitdisabled', false);
  //       setsubmitdisabled(false);
  //       setcreateSiebelCalled(false);
  //       for (let i = 0; i < blockedDomains.length; i++) {
  //         let index = value.indexOf(`@${blockedDomains[i]}`);
  //         if (index > -1) {
  //           setValidationError({ type: 'registeredEmail', value: true });
  //           if (createSiebelCalled) {
  //             setInSessionStorage(MODULE_ID, 'submitdisabled', true);
  //             setsubmitdisabled(true);
  //           }
  //         }
  //       }
  //     }
  //     if (!value.match(emailRegex) && value.length > 0) {
  //       setValidationError({ type: CUSTOMER_EMAIL, value: true });
  //     } else {
  //       setValidationError({ type: CUSTOMER_EMAIL, value: false });
  //     }
  //   } else if (type === CUSTOMER_PHONENUMER) {
  //     // check phoneNumber
  //     if (/^(\s*|\d+)$/.test(value) && value.length > 0 && value.length !== 10) {
  //       setValidationError({ type: CUSTOMER_PHONENUMER, value: true });
  //     } else {
  //       setValidationError({ type: CUSTOMER_PHONENUMER, value: false });
  //     }
  //   }
  // };

  const handleExpiredAndPending = (response) => {
    let feasibilityData = Object.assign(feasibilityCustomerDetailsConstant, {
      addressObj: {
        addressString: response.address?.addressString,
        city: response.address?.city
      },
      companyName: response.address?.companyName,
      requestedBandwidth: response?.requestedBandwidth?.toString(),
      pincode: response.address?.pincode?.toString() || response.address?.pinCode,
      address: response.address?.addressString,
      flatFloor: response.address?.flatFloor ?? '0',
      latitude: response.address?.latitude,
      longitude: response.address?.longitude
    });
    setFeasibilityData(feasibilityData);
    setShowFeasibilityId(false);
  };

  const handleFeasibilityCompletion = (data, onSubmitCb = () => {}) => {
    let mediatype = '';
    if (data && data.wirelineNetworkElement && data.wirelineNetworkElement.media) {
      mediatype = data.wirelineNetworkElement.media;
    } else if (data && data.offNetResponse && data.offNetResponse.offNetStatus) {
      mediatype = CAPEX_MEDIA_TYPE.offnet;
    } else if (data && data.thirdPartyResponse && Object.keys(data.thirdPartyResponse).length > 0) {
      mediatype = CAPEX_MEDIA_TYPE.thirdParty;
    } else if (data && data.wirelessNetworkElement && data.wirelessNetworkElement.technology) {
      mediatype = data.wirelessNetworkElement.technology;
    }
    let maxBandwidth =
      data && data.maxBandwidth
        ? data && data.maxBandwidth
        : data && data.wirelineNetworkElement && data.wirelineNetworkElement.maxBandwidth
        ? data.wirelineNetworkElement.maxBandwidth
        : data && data.wirelessNetworkElement && data.wirelessNetworkElement.maxBandwidth;
    // setInstAddressValidated(true);
    localStorage.setItem('media', mediatype);
    localStorage.setItem('maxBandwidth', maxBandwidth);
    setInSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE, data);
    onSubmitCb?.(data);
    faOnDedicatedCustomerDetailsLoad();
  };

  const checkFeasibilityById = (feasibilityId, feasibilityCustomerDetails, onSubmitCb = () => {}) => {
    let params = { feasibilityId };
    checkOftFeasibilityStatusDedicated(params)
      .then((response) => {
        let data = (response && response.data && response.data.result[0]) || feasibilityCustomerDetails;
        handleFeasibilityCompletion(data, onSubmitCb);
        if (!isShiftingJourney()) {
          sendOtp(feasibilityCustomerDetails);
        }
      })
      .catch((err) => {
        handleAPIError(err);
      });
  };

  const checkUserFeasibility = (feasibilityData, recommendedSiteSelected, onSubmitCb = () => {}) => {
    if (recommendedSiteSelected) {
      handleFeasibilityCompletion(feasibilityData);
      sendOtp(feasibilityData);
    }

    let feasibilityResponse = feasibilityData && feasibilityData.feasibilityResponse;
    if (feasibilityData && !feasibilityData.isFinalResponse) {
      return;
    }
    let customerDetails = feasibilityData && feasibilityData.customerDetails;
    let payLoad = {};
    let userAddress = {};
    let pincode = customerDetails && customerDetails.pincode;
    let addressString = customerDetails && customerDetails.address;
    let getFeasibilityCustomerDetails = feasibilityCustomerDetails;
    userAddress.pincode = pincode;
    userAddress.addressString = addressString;
    payLoad.queryId = feasibilityResponse && feasibilityResponse.queryId;
    payLoad.requestId = feasibilityResponse && feasibilityResponse.requestId;
    payLoad.product = DEDICATED_COMMON_PARAMS.serviceType === PRODUCT_TYPE.VPN ? 'MPLS' : 'INTERNET';

    if (DEDICATED_COMMON_PARAMS.serviceType === PRODUCT_TYPE.VPN) {
      payLoad.dualLastMile = customerDetails && customerDetails.lastMile && customerDetails.lastMile === 'Dual LM' ? true : false;
    }
    payLoad.userAddress = userAddress;
    payLoad.source = 'ONLINEACQ';
    getFeasibilityCustomerDetails.pincode = pincode;
    getFeasibilityCustomerDetails.address = addressString;
    getFeasibilityCustomerDetails.addressObj.addressString = addressString;
    getFeasibilityCustomerDetails.addressObj.city = customerDetails && customerDetails.selectedCity;
    getFeasibilityCustomerDetails.isHighRiseBuildingChecked = customerDetails && customerDetails.isHighRiseBuildingChecked;
    getFeasibilityCustomerDetails.flatFloor = customerDetails && customerDetails.flatFloor;
    getFeasibilityCustomerDetails.requestedBandwidth = customerDetails && customerDetails.requestedBandwidth;
    getFeasibilityCustomerDetails.lastMile = customerDetails && customerDetails.lastMile;
    getFeasibilityCustomerDetails.latitude = customerDetails && customerDetails.latitude;
    getFeasibilityCustomerDetails.longitude = customerDetails && customerDetails.longitude;

    setInSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA, { ...customerDetails, ...getFeasibilityCustomerDetails });
    setFeasibilityCustomerDetails(getFeasibilityCustomerDetails);
    if (isdedicatedJourney) {
      checkFeasibilityById(feasibilityResponse?.queryId, getFeasibilityCustomerDetails, onSubmitCb);
    } else {
      checkOftFeasibilityStatus(payLoad)
        .then((response) => {
          let data = response && response.data && response.data.result;
          // setInstAddressValidated(true);
          setInSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE, data);
          // scrollToTop();
          fireAnalyticsOnCustomerPageLoad();
          sendOtp(getFeasibilityCustomerDetails);
        })
        .catch((err) => {
          handleAPIError(err);
        });
    }
  };

  const getOftFields = () => {
    let productName = DEDICATED_COMMON_PARAMS.serviceType === PRODUCT_TYPE.VPN ? 'MPLS' : 'INTERNET';
    const leadId = getCurrentLead()?.leadId;
    let getRequestedBandwidth = selectedBandwidth;
    let request = {
      source: 'ATB_AUTH',
      product: productName,
      useCbftIntegration: false
    };
    if (leadId) {
      request.requestId = leadId;
    }
    if (getRequestedBandwidth) {
      request.requestedBandwidth = getRequestedBandwidth;
    }
    return request;
  };

  const sendOtp = (feasibilityCustomerDetails) => {
    // setDisabledProcced(true);
    const uniqueId = correlation();
    let phoneNumber = customer && customer.phoneNumber;
    let otpSuccess = customer && customer.otpSuccess;
    if (otpSuccess) {
      submitLead(feasibilityCustomerDetails);
    } else {
      // let exportUrl = appConfig.dedicatedoftApiBaseUrl + '&scope=mc_mnv_validate+phone&state=' + uniqueId + '&nonce=' + uniqueId + '&login_hint=91' + phoneNumber + '&acr_values=2';

      customer.uniqueId = uniqueId;
      setInSessionStorage(MODULE_ID, DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL, customer);
      //window.location.href = exportUrl;
      if (customerDetails) {
        customerDetails.companyName = customer && customer.companyName;
        setInSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL, customerDetails);
      }
      submitLead(feasibilityCustomerDetails);
    }
  };

  // const checkProceedStatus = () => {
  //   return (
  //     !getFromSessionStorage(MODULE_ID, 'submitdisabled') &&
  //     !createSiebelCalled &&
  //     customer.customerName != '' &&
  //     customer.companyName != '' &&
  //     customer.email != '' &&
  //     customer.phoneNumber != '' &&
  //     customer.phoneNumber.length === 10 &&
  //     !validationError.email &&
  //     !validationError.registeredEmail &&
  //     !validationError.phoneNumber &&
  //     !validationError.name
  //   );
  // };

  const submitLead = (feasibilityCustomerDetails) => {
    let finalPayload = Object.assign({}, customer);
    let getFeasibilityCustomerDetails = feasibilityCustomerDetails || getfeasibilityData;
    finalPayload.pinCode =
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.pincode) ||
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.address && getFeasibilityCustomerDetails.address.pincode);

    finalPayload.cityName =
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.addressObj && getFeasibilityCustomerDetails.addressObj.city) ||
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.address && getFeasibilityCustomerDetails.address.city);

    finalPayload.address =
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.addressObj && getFeasibilityCustomerDetails.addressObj.addressString) ||
      (getFeasibilityCustomerDetails && getFeasibilityCustomerDetails.address && getFeasibilityCustomerDetails.address.addressString);

    // to do add feasibility response
    let updateCustomerData = authToken ? true : false;
    let getdedicatedFeasibilityData = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
    finalPayload.leadSource = 'ONLINE_FEASIBILITY_CHECK';
    if (getdedicatedFeasibilityData && getdedicatedFeasibilityData.feasibilityId) {
      finalPayload.feasibilityId = getdedicatedFeasibilityData.feasibilityId;
    }
    if (getdedicatedFeasibilityData && getdedicatedFeasibilityData.feasibilityStatus) {
      finalPayload.feasibilityStatus = getdedicatedFeasibilityData.feasibilityStatus;
    }
    faOnDedicatedProceedClick(finalPayload);
    createLead(finalPayload, updateCustomerData, isdedicatedJourney)
      .then((response) => {
        let responsesData = response && response.data && response.data.result;
        let segment = responsesData && responsesData.customerSegment;
        let auth_token = response && response.headers && response.headers.authorization_token;

        const savedAuthSignatory = getFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
        const savedCustomerSegment = (savedAuthSignatory && savedAuthSignatory.customerSegment) || '';

        if (auth_token) {
          setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
          localStorage.setItem('storageTime', new Date());
        }

        // setContactDetailsValidated(true);
        if (!updateCustomerData && segment) {
          faOnDedicatedAuthCheckFeasibiliyPage({ segment, productType });
        }
        // TO DO -- uncoment dis before SIT
        // submitSiebelLead();

        // comment below before SIT
        // redirectToPage()
        gtag_report_conversion_lead_submitted();
        if (savedCustomerSegment === 'ENTERPRISE') {
          redirectToPage();
        } else {
          submitSiebelLead();
        }
      })
      .catch((err) => {
        // setDisabledProcced(false);
        handleAPIError(err);
        setCustomer({ ...customer, otpSuccess: false });
        setAccordionState({
          type: 'customer',
          value: true
        });
        // setInstAddressValidated(false);
        scrollIntoView(dedicatedAccordianRef, 'end');
      });
  };

  const submitSiebelLead = () => {
    createSiebelLead(isdedicatedJourney)
      .then((response) => {
        // setDisabledProcced(false);
        // end API call
        if (!localStorage.getItem('accessToken') && isdedicatedJourney) {
          // if (validationError.registeredEmail) {
          //   setInSessionStorage(MODULE_ID, 'submitdisabled', true);
          //   // setsubmitdisabled(true);
          //   // setcreateSiebelCalled(true);
          //   return;
          // }
        }
        redirectToPage();
        setAPIFetechingState({ type: FETCH_SUCCESS });
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        // setDisabledProcced(false);
        handleAPIError(err);
      });
  };

  const handleAPIError = (error) => {
    let alertTitle = "We're Sorry!!!";
    let alertmsg = '';
    // to do - handle error
    if (error && error.response && error.response.status === '400') {
      alertmsg = error.response.data.errorMsg;
    } else {
      alertmsg = 'Oops!!! something went wrong. Please try after some time';
    }
    setAPIFetechingState({
      type: FETCH_ERROR,
      alertData: {
        alertTitle: alertTitle,
        alertmsg: alertmsg,
        showAlert: true
      }
    });
  };

  const scrollIntoView = (ref, block) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block });
    }
  };

  // const onCustomerDetailSubmit = () => {
  //   if (isUnAuthJourney) {
  //     trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_SUBMIT_CUSTOMER_DEATILS, {
  //       ...customer
  //     });
  //     facebookNextButtonTag();
  //   } else {
  //     trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.SUBMIT_CUSTOMER_DEATILS, {
  //       ...customer
  //     });
  //   }
  //   gtag_report_conversion_customer_details();
  //   setContactDetailsValidated(true);
  //   setAccordionState({ type: 'installation_success' });
  // };

  const fetchProductBandwidthMbps = () => {
    let payload = {};
    payload.configFields = 'PRODUCT_BANDWIDTH';
    payload.productType = DEDICATED_COMMON_PARAMS.serviceType;
    getCommercialAttributesList(payload)
      .then((response) => {
        let productBandwidthMbps = response && response.data && response.data.result && response.data.result.productBandwidthMbps;
        setBandWidthList(productBandwidthMbps ? mapToBandWidthList(productBandwidthMbps) : BANDWIDTH_LIST);
      })
      .catch((err) => {});
  };

  const onProceedFromFeasibilityId = ({ feasibilityResponse, feasibilityCustomerDetails, isExpiredOrPending }) => {
    if (isExpiredOrPending) {
      handleExpiredAndPending(feasibilityResponse);
      return false;
    }
    handleFeasibilityCompletion(feasibilityResponse, onAddFeasibilitySuccess);

    if (!isShiftingJourney()) {
      submitLead(feasibilityCustomerDetails);
    }
  };

  const handleCancelLead = async (remarks) => {
    try {
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);
      const reqData = {
        remarks
      };
      const cancelLeadFn = () => {
        if (isShiftingJourney()) {
          return cancelPnQLead?.(remarks);
        }

        return cancelLead(reqData, leadAuthToken, isdedicatedJourney);
      };

      const { res, err } = await cancelLeadFn();
      if (res) {
        const { data: { success = false } = {} } = res;
        if (success) {
          setToast(false, '', '');
          const partyId = findParamFromUrl('partyId', false);
          const leadId = getCurrentLead()?.leadId;
          let redirectUrl = ROUTES.DEDICATED_CANCEL;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          history && history.push(redirectUrl, { ...getOrderDetails(leadId), isUpgrade: isBulkUpgrade() });
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);

        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const renderAccordion = (children) => {
    // if (isUnAuthJourney) {
    //   return (
    //     <Accordion
    //       autoScrollOnExpand={false}
    //       title={getInstallationDetailsAccordionHeading(false, selectedRadio)}
    //       isExpanded={accordionState.installation}
    //       isValidated={instAddressValidated}
    //       onClick={() =>
    //         setAccordionState({
    //           type: 'installation',
    //           value: !accordionState.installation
    //         })
    //       }
    //       isEditable={accordionState.installation}
    //       onEditClick={() =>
    //         setAccordionState({
    //           type: 'installation',
    //           value: !accordionState.installation
    //         })
    //       }
    //       onExpandClick={() =>
    //         setAccordionState({
    //           type: 'installation',
    //           value: !accordionState.installation
    //         })
    //       }
    //       variant={getAccordionVariant(isUnAuthJourney)}
    //     >
    //       {children}
    //     </Accordion>
    //   );
    // }

    return (
      <Accordion
        autoScrollOnExpand={true}
        title={showFeasibilityId ? getInstallationDetailsAccordionHeading(true) : getInstallationDetailsAccordionHeading(false, selectedRadio)}
        isExpanded={accordionState.installation}
        onExpandClick={() =>
          setAccordionState({
            type: 'installation',
            value: !accordionState.installation
          })
        }
        variant={getAccordionVariant(isUnAuthJourney)}
      >
        {children}
      </Accordion>
    );
  };

  const showLastMile = () => {
    if (!showLastMileField) {
      return false;
    }

    if (getCurrentLead()?.serviceType) {
      return getCurrentLead()?.serviceType === PRODUCT_TYPE.VPN;
    }

    return DEDICATED_COMMON_PARAMS.serviceType === PRODUCT_TYPE.VPN;
  };

  const showAddFeasibilityIdSection = () => {
    if (isUnAuthJourney) {
      return false;
    }

    return showAddFeasibilityId;
  };

  const getBandwidthList = () => {
    if (!showBandwidthField) {
      return [];
    }

    return bandWidthList;
  };

  const getInstallationSection = () => {
    return (
      <div className="accordion-outer">
        {showFeasibilityId ? (
          <FeasibilityID
            setShowFeasibilityId={setShowFeasibilityId}
            processFeasibilityResponse={onProceedFromFeasibilityId}
            // setInstAddressValidated={setInstAddressValidated}
          ></FeasibilityID>
        ) : (
          <>
            {showAddFeasibilityIdSection() && (
              // <Checkbox checked={showFeasibilityId} onChange={checked => setShowFeasibilityId(checked)}>
              <div className="feasibility_info_text">
                Get existing feasible installation details with a feasibility ID.{' '}
                <span className="link_text" onClick={() => setShowFeasibilityId(true)}>
                  {' '}
                  Add feasibility ID
                </span>
              </div>
              // </Checkbox>
            )}
            {!isUnAuthJourney ? (
              <B2bCommonFeasibilityWidget
                isB2BRequest={true}
                plan={planObj}
                bandWidthList={getBandwidthList()}
                requestorSource={'ATB_AUTH'}
                pageName={'Dedicated'}
                environment="PROD"
                showNameField={false}
                showMobileNumberField={false}
                showPincodeField={true}
                showLatitudeField={showLatField}
                showLongitudeField={showLongField}
                buttonText={'Next'}
                theme={'app_blue'}
                requestId={uuidv4()}
                customerDetails={feasibilityData}
                customFeasibilityApiFields={getOftFields()}
                showB2bOnlyCities={true}
                customFeasibilityApi={appConfig.oftCheckFeasibilityApi}
                processFeasibilityResponse={processFeasibilityResponse}
                showLastMile={showLastMile()}
                alwaysShowFlatFloorField={false}
                showOutOfCityModal={false}
                // showRecommendedFeasibility={!isUnAuthJourney}
                recommendedFeasibilityOftApi={appConfig.recommendedFeasibilityOftApi}
                showHouseNumberField={true}
                getCityByPincodeApi={appConfig.getCityByPincodeApi}
                productName={DEDICATED_COMMON_PARAMS.serviceType}
                // showCancelButton={!isUnAuthJourney}
                // cancelButtonClassname="button-class b2b-lib-outlinebtn"
                // onCancelButtonClick={() => setShowCancelLeadPopup(true)}
              />
            ) : (
              <iframe
                allow="geolocation *"
                id="test-widget"
                ref={widgetFrameRef}
                src="https://airtelp2p.bsbportal.com/omniwidget-desktop/?lob=BROADBAND&pageName=SAFO_LEAD_PAGE&requestorSource=DCAT_APP"
              ></iframe>
            )}

            {!isUnAuthJourney && <Button displayName="Cancel" buttonClass="button-class" variant="outlinebtn" onClick={() => setShowCancelLeadPopup(true)} />}
          </>
        )}
      </div>
    );
  };

  // const renderContactDetailsAccordion = () => {
  //   if (isUnAuthJourney) {
  //     return (
  //       <Accordion
  //         autoScrollOnExpand={false}
  //         title="Contact Details"
  //         isExpanded={accordionState.customer}
  //         onClick={() =>
  //           setAccordionState({
  //             type: 'customer',
  //             value: !accordionState.customer
  //           })
  //         }
  //         onExpandClick={() =>
  //           setAccordionState({
  //             type: 'customer',
  //             value: !accordionState.customer
  //           })
  //         }
  //         isEditable={accordionState.customer}
  //         isValidated={contactDetailsValidated}
  //         onEditClick={() =>
  //           setAccordionState({
  //             type: 'customer',
  //             value: !accordionState.customer
  //           })
  //         }
  //       >
  //         <div className="accordion-outer">
  //           <div className="accordion-content">
  //             {/* <div className="info-text">
  //         Share your details to view plans in your area.
  //       </div> */}
  //             <div className="form-box" ref={contactRef}>
  //               <div className="form-row">
  //                 <div className="col-5">
  //                   <div className="field-control">
  //                     <Input
  //                       type="text"
  //                       label="Full Name"
  //                       name="customerName"
  //                       value={customer && customer.customerName}
  //                       onChange={(value) =>
  //                         updateCustomer({
  //                           type: CUSTOMER_NAME,
  //                           value
  //                         })
  //                       }
  //                       maxLength="150"
  //                       errors={[]}
  //                       required
  //                       touched={false}
  //                       autoComplete="off"
  //                     />
  //                   </div>
  //                 </div>
  //                 <div className="col-5">
  //                   <div className="field-control">
  //                     <Input
  //                       type="text"
  //                       label="Company Name"
  //                       value={customer && customer.companyName}
  //                       onChange={(value) =>
  //                         updateCustomer({
  //                           type: CUSTOMER_COMPANY_NAME,
  //                           value
  //                         })
  //                       }
  //                       maxLength="250"
  //                       errors={[]}
  //                       required
  //                       touched={false}
  //                       autoComplete="off"
  //                       onpaste="return false"
  //                     />
  //                   </div>
  //                 </div>
  //               </div>
  //               <div className="form-row">
  //                 <div className="col-5">
  //                   <div className="field-control">
  //                     <div className="b2b-lib-inputContainer">
  //                       <input
  //                         type="email"
  //                         id="emailId"
  //                         name="emailId"
  //                         className={`b2b-lib-input ${validationError.email || validationError.registeredEmail ? 'b2b-lib-error' : ''}`}
  //                         value={customer && customer.email}
  //                         onBlur={(event) =>
  //                           checkValidation({
  //                             type: CUSTOMER_EMAIL,
  //                             value: event.target.value
  //                           })
  //                         }
  //                         onChange={(event) =>
  //                           updateCustomer({
  //                             type: CUSTOMER_EMAIL,
  //                             value: event.target.value
  //                           })
  //                         }
  //                         placeholder=" "
  //                         autoComplete="off"
  //                       />
  //                       <label className="b2b-lib-label">Official Email ID</label>
  //                       {validationError.email && <div className="error">invalid email address</div>}
  //                       {validationError.registeredEmail && <div className="error">Please enter official email address</div>}
  //                     </div>
  //                   </div>
  //                 </div>
  //                 <div className="col-5">
  //                   <div className={`field-control instruction-content ${customer.otpSuccess ? 'got-success' : validationError.phoneNumber ? 'b2b-lib-error' : ''}`}>
  //                     <Input
  //                       type="text"
  //                       label="Enter Mobile Number"
  //                       name="mobileNumber"
  //                       value={customer && customer.phoneNumber}
  //                       isValidChange={(value) => /^(\s*|\d+)$/.test(value)}
  //                       onBlur={(event) =>
  //                         checkValidation({
  //                           type: CUSTOMER_PHONENUMER,
  //                           value: event.target.value
  //                         })
  //                       }
  //                       onChange={(value) =>
  //                         updateCustomer({
  //                           type: CUSTOMER_PHONENUMER,
  //                           value
  //                         })
  //                       }
  //                       maxLength="10"
  //                       errors={[]}
  //                       required
  //                       touched={false}
  //                       autoComplete="off"
  //                     />
  //                     <div className={`instruction-link ${customer && customer.phoneNumber ? '' : 'disabled'}`} onClick={sendOtp}>
  //                       {validationError.phoneNumber ? (
  //                         <div className="error">invalid phone number</div>
  //                       ) : customer.otpSuccess ? (
  //                         ''
  //                       ) : customer.phoneNumber && customer.phoneNumber.length === 10 ? (
  //                         !validationError.otpError ? (
  //                           ''
  //                         ) : (
  //                           ''
  //                         )
  //                       ) : (
  //                         ''
  //                       )}
  //                     </div>
  //                     {validationError.otpError && <div className="error">invalid OTP. Please try again</div>}{' '}
  //                     {customer.otpSuccess && <div className="success">Successfully verified</div>}
  //                   </div>
  //                 </div>
  //               </div>
  //               <div>
  //                 {disabledProcced ? (
  //                   <Button className="btn" disabled={true}>
  //                     Next
  //                   </Button>
  //                 ) : (
  //                   <Button className="btn" disabled={!checkProceedStatus()} onClick={onCustomerDetailSubmit}>
  //                     Next
  //                   </Button>
  //                 )}

  //                 {/* add class "btn-active" when form filled */}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </Accordion>
  //     );
  //   }
  // };

  const renderInstallationDetailsAccordion = () => {
    if (showAccordion) {
      return renderAccordion(getInstallationSection());
    }

    return getInstallationSection();
  };

  const wrapperParentClassNames = classNames({
    'progress-section': true,
    'auth-view': !isUnAuthJourney
  });

  const wrapperChildClassNames = classNames({
    'wrapper check-feasibility-container': true,
    'wrapper-relative ': !accordionState.installation,
    'auth-container': !isUnAuthJourney
  });

  return (
    <React.Fragment>
      <section ref={dedicatedAccordianRef} className={wrapperParentClassNames}>
        <div className={wrapperChildClassNames}>
          {fetchState.loader ? (
            <div className="round-loader">
              <MainLoader />
              <p className="loader-heading">
                <span className="color-red">Loading…</span>
                <br />
                Please Wait.
              </p>
            </div>
          ) : (
            <React.Fragment>
              {showCanceLeadPopup && <CancelModal setshowPopup={setShowCancelLeadPopup} onSubmit={handleCancelLead} />}
              {/* {renderContactDetailsAccordion()} */}
              {renderInstallationDetailsAccordion()}
              {!accordionState.installation && getfeasibilityData && getfeasibilityData.addressObj && getfeasibilityData.addressObj.addressString && (
                <div className="show-address">
                  {/* {getfeasibilityData && getfeasibilityData.flatFloor}{" "}
                  {getfeasibilityData.addressObj.addressString} */}
                </div>
              )}
              <div
                ref={contactRef}
                className={getfeasibilityData && getfeasibilityData.addressObj && getfeasibilityData.addressObj.addressString ? '' : 'disabled-accordion'}
              ></div>
            </React.Fragment>
          )}
        </div>
      </section>
    </React.Fragment>
  );
}

export default AccordionComponent;
